export default "__VITE_PUBLIC_ASSET__f4b649cc__"